// apiClient.js
import axios from 'axios';

// Create an Axios instance
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL, // Base URL for your API
  headers: {
    'Content-Type': 'application/json', // Default Content-Type
  },
});

// Add a request interceptor to dynamically set the Authorization header
apiClient.interceptors.request.use((config) => {
  // Retrieve the token from sessionStorage or localStorage
  const token = sessionStorage.getItem('token') || localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
}, (error) => {
  return Promise.reject(error);
});


apiClient.interceptors.response.use(function (response) {
  // Optional: Do something with response data
  return response;
}, function (error) {

   // This will be used for redirection to login

    // Check if the error is due to token expiry (assuming the API returns a 401 status for expired token)
    if (error.response && error.response.status === 401) {
      sessionStorage.clear();
      //localStorage.clear();
      localStorage.removeItem("token");
      localStorage.removeItem("userDetails");
      // Clear token from localStorage
      // localStorage.removeItem('userDetails');
      // localStorage.removeItem('token');
      // localStorage.removeItem('userToken')
      
      // Redirect to login page
      // if (window.location.pathname !== '/') {
      //   window.location.replace('/');
      // }
      
    }

  return Promise.reject(error);
});

const apiClientPowerBI = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_POWERBI, // Base URL for your API
  headers: {
    'Content-Type': 'application/json', // Default Content-Type
  },
});

// Add a request interceptor to dynamically set the Authorization header
apiClientPowerBI.interceptors.request.use((config) => {
  // Retrieve the token from sessionStorage or localStorage
  const token = sessionStorage.getItem('token') || localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export {apiClientPowerBI};
export default apiClient;
// -----------------------------------------------------------------------------------------------------
// import axios from 'axios';

// // Create an Axios instance
// const apiClient = axios.create({
//   baseURL: process.env.REACT_APP_BASE_URL, // Base URL for your API
//   headers: {
//     'Content-Type': 'application/json', // Default Content-Type
//   },
// });

// // Add a request interceptor to dynamically set the x-user-data header
// apiClient.interceptors.request.use((config) => {
//   // Retrieve the userToken from localStorage
//   const userToken = localStorage.getItem('userToken'); // Change to userToken

//   if (userToken) {
//     // Set the x-user-data header
//     config.headers['x-user-data'] = userToken;
//   }
  
//   return config;
// }, (error) => {
//   return Promise.reject(error);
// });

// const apiClientPowerBI = axios.create({
//   baseURL: process.env.REACT_APP_BASE_URL_POWERBI, // Base URL for your API
//   headers: {
//     'Content-Type': 'application/json', // Default Content-Type
//   },
// });

// // Add a request interceptor to dynamically set the x-user-data header for PowerBI client
// apiClientPowerBI.interceptors.request.use((config) => {
//   // Retrieve the userToken from localStorage
//   const userToken = localStorage.getItem('userToken'); // Change to userToken
  
//   if (userToken) {
//     // Set the x-user-data header
//     config.headers['x-user-data'] = userToken;
//   }
  
//   return config;
// }, (error) => {
//   return Promise.reject(error);
// });

// export { apiClientPowerBI };
// export default apiClient;
